<template>
    <div :class="'wy-card ' + (needBottom? 'card-boder-bottom': '')" :style="StylesObj">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'wy-card',
    props: {
        backgroundColor: {
            type: String,
            default: "#fff"
        },
        padding: {
            type: String,
            default: '0.15rem'
        },
        needBottom: {
            type: Boolean,
            default: false,
        },
        margin: {
            type: String,
            default: '0'
        }
    },
    data() {
        return {
            StylesObj: {
                backgroundColor: this.backgroundColor,
                padding: this.padding,
                margin: this.margin,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.wy-card{
    overflow: hidden;
    @include border-radius(0.1rem);
    @include box-sizing(border-box);
}
.card-boder-bottom{
    border-bottom: 1px dashed #F3F3F3;
}
</style>
